import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/admin/login?err=nohash", { replace: true });
      return;
    }
    const sessionId = decodeURIComponent(match[1]);

    (async () => {
      try {
        const { data } = await api.post("/auth/emergent-session", { session_id: sessionId });
        // Clean the hash so it never re-triggers
        window.history.replaceState(null, "", window.location.pathname + window.location.search);
        setUser(data.user);
        if (data.is_admin) {
          navigate("/admin", { replace: true });
        } else {
          navigate("/admin/login?denied=1", { replace: true });
        }
      } catch (e) {
        navigate("/admin/login?err=fail", { replace: true });
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#0A2540] text-white" data-testid="auth-callback">
      <div className="text-center">
        <div className="mx-auto mb-6 h-10 w-10 animate-spin rounded-full border-2 border-white/20 border-t-[#34D8A0]" />
        <p className="font-mono text-xs uppercase tracking-overline text-white/60">Signing you in…</p>
      </div>
    </div>
  );
}
